import { type FirebaseApp, initializeApp } from '@firebase/app';
import { clientConfig } from './clientConfig.ts';
import { connectEmulators } from './connectEmulators.ts';

let app: FirebaseApp;

export const getApp = () => {
    if (!app) {
        app = initializeApp(clientConfig);
        if (process.env.PUBLIC_USE_EMULATORS === 'true') {
            connectEmulators(app);
        }
    }
    return app;
};
